import { isProductionConfigSource } from './statsig';

export const analyticsEnvironments = {
    PROD: 'prod',
    DEVELOPMENT: 'dev',
};

export const resolveAnalyticsEnvironment = (configSource) => (
    isProductionConfigSource(configSource) ? analyticsEnvironments.PROD : analyticsEnvironments.DEVELOPMENT
);

export const buildUserIdentifiedEvent = (user, environment) => ({
    event: 'user_identified',
    user_id: user?.id ?? null,
    env: environment,
});

export const getFreshchatRestoreId = (createdResponse) => (
    createdResponse?.status === 200 ? (createdResponse.data?.restoreId ?? null) : null
);

export const buildAppWrapperClassName = ({
    env,
    showExpandedNav,
    expandedNavTitleClass,
    loggedOut,
    noHeader,
    customHeader,
    transparentHeader,
    activatingUtr,
    isImpersonating,
    mobileWebView,
}) => [
    'theme-v2',
    showExpandedNav && `expanded-nav ${expandedNavTitleClass}`.trim(),
    loggedOut && 'logged-out',
    noHeader && 'no-header',
    customHeader && 'custom-header',
    transparentHeader && 'transparent',
    activatingUtr && 'activating-utr',
    isImpersonating && 'impersonating',
    mobileWebView && 'web-view',
    env,
].filter(Boolean).join(' ');
